.dropzone {
  min-height: 100px;
}
.row {
  margin-left: -20px;
  width: 500px;
}
.row:after {
  content: '';
  display: table;
  clear: both;
}
.draggingOver {
  border: 1px dashed #ccc;
  border-radius: 2px;
  background: #efefef
}
.noResults {
  text-align: center;
  color: #ccc;
  padding: 40px;
}